import React from 'react';
import GridProps from "./props";
import GridItem from './components/GridItem';
import './style.scss';

const GRID_COLUMNS = 12;

function Grid({ cells, items, columns }: GridProps) {

  const gridStyle = {
    gridTemplateColumns: `repeat(${GRID_COLUMNS}, 1fr)`,
  };

  const getSpan = (cols?: number) => {
    if (cols) {
      return GRID_COLUMNS / cols;
    }

    if (columns) {
      return GRID_COLUMNS / columns;
    }

    return 4;
  };

  return (
    <div className='grid' style={gridStyle} data-e2e='grid'>
      {Array.from({ length: cells }).map((_, index) => {
        const item = items?.[index];
        // Default to 3 columns if not specified
        const span = getSpan(item?.cols);
        return (
          <GridItem key={index} span={span} index={index}>
            {item?.content || <div>Loading...</div>}
          </GridItem>
        );
      })}
    </div>
  );
}

export default React.memo(Grid);